/**
 * SDD Appendix A, "Schedule held reason" and "Schedule disabled reason" (S-684),
 * in words. A token not in these lists is shown as given, never dropped: the
 * vocabulary can grow.
 *
 * Its own module (2.718) because a notification names a disabled reason too
 * (ADR-101's `schedule.disabled`), and the notification client sits under the
 * shell's bell, in the entry chunk: importing the schedules client there would
 * ship the cron parser on every first load.
 */
const HELD_WORDS: Record<string, string> = {
  // Not "not complete": KYC can also have EXPIRED (ADR-069).
  kyc_not_verified: "the organisation is not currently verified (KYC)",
  scan_profile_unavailable: "its scan profile is no longer offered",
};
const DISABLED_WORDS: Record<string, string> = {
  requested: "switched off on request",
  owner_lacks_authority: "its owner no longer has the authority to launch these scans",
  scope_forbidden: "its scope is no longer permitted",
  scope_too_broad: "its scope is too broad",
  target_archived: "its target was archived",
  auth_profile_revoked: "an auth profile it uses was revoked",
  one_shot_done: "its one run has happened",
};
export const heldWords = (t: string) => HELD_WORDS[t] ?? `"${t}" (not one this console knows)`;
export const disabledWords = (t: string) => DISABLED_WORDS[t] ?? `"${t}" (not one this console knows)`;
